import { fetchApi } from '@/config/axiosSetting';
import {
  VisitInformationResponseType,
  VisitInformationTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';

export const getVisitInformationQueryFunction = (
  params: VisitInformationTypeParams,
): Promise<VisitInformationResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/adjusting/visit_information/`,
    {
      params: {
        id: params.id,
        damaged_id: params.damaged_id,
        source: params.source,
      },
    },
  );
};
